


























import { Component, Vue, Prop } from "nuxt-property-decorator";
import UserIcon from "~/components/UserIcon.vue";
import { Calendar } from "~/types/adventar";
import { getToday } from "~/lib/Configuration";

@Component({
  components: { UserIcon }
})
export default class extends Vue {
  @Prop() readonly calendar: Calendar;

  isFutureEntry(entry): boolean {
    // TODO: Fix to JST
    return new Date(this.calendar.year, 11, entry.day) > getToday();
  }

  isValidUrl(url: string | undefined) {
    return url != null && url != "" && /^https?:\/\//.test(url.trim());
  }
}
